<div class="sunburst-content">
    <div class="sunburst" #sunburst [ngStyle]="{'max-width.px': chartSize}">
        <ng-container *ngIf="mainPartition">
            <div *ngIf="showedLabel && showedValue" class="part-details">
                <h4>{{ showedLabel }}</h4>
                <div class="part-value">{{ showedValue }}</div>
            </div>
            <div *ngIf="!showedLabel || !showedValue" class="part-how-to">
                {{ 'citizen.chart.howTo.fullLabel' | translate }}
            </div>
        </ng-container>
    </div>
</div>
